<template>
  <div>
    <h3 v-if="title">{{ title }}</h3>
    <v-select
      label="Select"
      :items="values"
      :value="innerModel"
      :error="error.$dirty && error.$invalid"
      :error-messages="errorMessage"
      @input="onInput($event)"
    />
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import generateErrorMessage from '@/utils/generateErrorMsg'
  import { any, map, propEq, find, isEmpty } from 'ramda'

  export default {
    name: 'EMultiselect',
    data () {
      return {
        innerModel: null,
        values: []
      }
    },
    props: {
      title: {
        type: String
      },
      value: {
        type: String,
        required: true
      },
      error: {
        type: Object,
        default: () => ({})
      },
      fieldLayout: {
        type: Object
      }
    },
    computed: {
      ...mapGetters([
        'categoriesList'
      ]),
      errorMessage () {
        return generateErrorMessage(this.error, [])
      }
    },
    methods: {
      ...mapActions([
        'getCategoriesList'
      ]),
      onInput (event) {
        this.$emit('input', event)
      },
      // if type 'select' use fieldLayout.values or values from outer source by CollectionReferenceName
      async prepareSelectValues () {
        let outerValuesSource = ''
        const config = {
          'categories': await this.getCategoriesList({page: 0, itemsOnPage: 9999 })
        }
        const isObjectId = validator => {
          if (validator.name === 'objectId'){
            outerValuesSource = validator.data.CollectionReferenceName
            return true
          } else {
            outerValuesSource = ''
            return false
          }
        }

        if ( any(isObjectId, this.fieldLayout.validators) ) {
          try {
            const categories = map(category => ({text: category.name, value: category.id}), config[outerValuesSource])
            const defaultValue = find(propEq('value', this.value))(categories)
            this.innerModel = defaultValue || categories[0]
            this.$emit('input', this.innerModel.value)
            this.values = categories
          } catch (err) {
            console.log('Unknown select values source')
          }
        } else {
          this.values = this.fieldLayout.values || []
        }
      }
    },
    mounted () {
      this.prepareSelectValues()
      this.innerModel = this.value
      if (this.innerModel && !isEmpty(this.error)) {
        this.error.$touch()
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/shared/EMultiselect/index.vue